import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from 'rxjs';
import { LoginClient, LoginModel, TokenModel } from "./client";

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private userModel: LoginModel = new LoginModel();
    public auth: BehaviorSubject<TokenModel | null>;
    constructor(private client: LoginClient) {
        this.auth = new BehaviorSubject<TokenModel | null>(null);
    }

    loginIn(login: LoginModel): Observable<TokenModel> {
        return this.client.login(login);
    }

    setToken(token: TokenModel): Observable<boolean> {
      localStorage.clear();
      localStorage.setItem('token', 'Bearer ' + token.token);
      localStorage.setItem('tokenModel', JSON.stringify(token));
      return of(true);
    }

    valid(): boolean {
        if (localStorage.getItem('token') === null || localStorage.getItem('token') === undefined) {
            return false;
        }
        return true;
    }
}

